import { trackChangesKey } from 'common/Prose/Plugins/TrackChanges/constants'
import { observer } from 'mobx-react-lite'
import { useProseInstance } from 'providers/ProseInstanceProvider'
import { useEffect } from 'react'
import { useDocStore } from 'stores/DocStore'

const TrackedChangesStoreSync = observer(() => {
  const proseView = useProseInstance()
  const docStore = useDocStore()

  useEffect(() => {
    if (!proseView.currentView) {
      return
    }
    const pluginStore = trackChangesKey.getState(proseView.currentView.state)?.store
    if (docStore && pluginStore) {
      docStore.setTrackedChanges(pluginStore)
    }
  }, [proseView.currentView, docStore])

  return null
})

export default TrackedChangesStoreSync
